import API from "./index";

class UsuarioService {
  constructor() {
    this.path = `/api/sgu/usuarios`;
  }

  mudarDepartamentoUsuario(id, idDepartamento) {

    return API.put(`${this.path}/mudarDepartamentoUsuario/${id}/${idDepartamento}`);

  }
}

export default UsuarioService;
